var _path, _path2, _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPickupPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.21 23.86c6.59 0 11.93-5.341 11.93-11.93C27.14 5.34 21.8 0 15.21 0 8.623 0 3.28 5.341 3.28 11.93c0 6.588 5.342 11.93 11.93 11.93zm2.534 1.174c.746-.156 1.262-.264 1.37-.058.211.404-3.444 4.659-4.011 4.659-.567 0-4.222-4.256-4.011-4.66.107-.205.624-.097 1.37.059.72.15 1.655.346 2.64.346.987 0 1.921-.196 2.642-.346z",
    fill: "url(#1w557a1n6a)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "y53ieiaofb",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 25,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.21 23.86c6.59 0 11.93-5.341 11.93-11.93C27.14 5.34 21.8 0 15.21 0 8.623 0 3.28 5.341 3.28 11.93c0 6.588 5.342 11.93 11.93 11.93zm2.534 1.174c.746-.156 1.262-.264 1.37-.058.211.404-3.444 4.659-4.011 4.659-.567 0-4.222-4.256-4.011-4.66.107-.205.624-.097 1.37.059.72.15 1.655.346 2.64.346.987 0 1.921-.196 2.642-.346z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#y53ieiaofb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a0y15chm9c)",
    d: "M2.982 0h24.456v29.825H2.982z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.21,
    cy: 11.93,
    r: 4.772,
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "1w557a1n6a",
    x1: 3.281,
    y1: 0,
    x2: 3.281,
    y2: 29.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1080FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a0y15chm9c",
    x1: 15.21,
    y1: 0,
    x2: 15.21,
    y2: 29.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37B8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34ABE1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPickupPin);
export default __webpack_public_path__ + "static/media/ic_pickup_pin.4f90e6f4a9e52b31e05af8111b527018.svg";
export { ForwardRef as ReactComponent };